import { Link } from 'react-router-dom';

import { MarketTopSalesResponse } from 'api/market';
import { buildPathParams } from 'utils/routes';
import { Routes } from 'constants/routes';

import Avatar from 'shared_components/Avatar';
import CurrencyValue from 'shared_components/CurrencyValue';
import Text from 'shared_components/Text';

import styles from './styles.module.scss';

const TopSalesItem = (props: MarketTopSalesResponse['top'][number]) => {
  const { card, price, user, updated, entityType } = props;

  return (
    <Link
      to={{
        pathname: buildPathParams(Routes.card, {
          id: card.uuid,
        }),
        state: { initialTabIndex: 3 },
      }}
      className={styles.marketTemplateItem}
      key={entityType + card.uuid + price + updated}
    >
      <div className={styles.card}>
        <img
          src={card.images.size402}
          alt={card.uuid}
          className={styles.cardImage}
        />
      </div>
      <div className={styles.artistInfo}>
        <Avatar src={user.avatar} groups={user.groups} size={40} />
        <div className={styles.artistRight}>
          <Text block size="xs" type="muted" className={styles.marketTitle}>
            Sold By
          </Text>
          <Text
            block
            type="white"
            weight="semibold"
            size="sm"
            className={styles.artistName}
          >
            {user.username}
          </Text>
        </div>
      </div>
      <div className={styles.valueFooter}>
        <Text size="xs" weight="semibold" uppercase>
          Sold For
        </Text>
        {/* cannot show accurate USD unless we stored eth-price at sale-time */}
        <CurrencyValue size={18} value={price} />
      </div>
    </Link>
  );
};

export default TopSalesItem;
